import { inferRegionCode } from "@src/packages/costs/estimates/locations";

const POSTAL_PATTERNS: Record<string, RegExp> = {
  GB: /^(?:GIR 0AA|[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2})$/i,
  CA: /^[A-Z]\d[A-Z] ?\d[A-Z]\d$/i,
  AU: /^\d{4}$/,
  DE: /^\d{5}$/,
  FR: /^\d{5}$/,
  ES: /^\d{5}$/,
  IT: /^\d{5}$/,
  NL: /^\d{4} ?[A-Z]{2}$/i,
  SE: /^\d{3} ?\d{2}$/,
  CH: /^\d{4}$/,
  IE: /^[A-Z]\d{2} ?[A-Z\d]{4}$/i,
  NZ: /^\d{4}$/,
  SG: /^\d{6}$/,
  JP: /^\d{3}-?\d{4}$/,
  KR: /^\d{5}$/,
  IN: /^\d{6}$/,
  AE: /^\d{5}$/,
  IL: /^\d{7}$/,
  BR: /^\d{5}-?\d{3}$/,
  MX: /^\d{5}$/,
  ZA: /^\d{4}$/,
};

export function normalizePostalCode(countryCode: string, postalCode: string) {
  const normalized = postalCode.trim().replace(/\s+/g, " ");
  return countryCode === "US" ? normalized.replace(/\s/g, "") : normalized;
}

export function isPostalCodeRequired(countryCode: string): boolean {
  const normalizedCountryCode = countryCode.toUpperCase();
  return (
    normalizedCountryCode === "US" ||
    Object.hasOwn(POSTAL_PATTERNS, normalizedCountryCode)
  );
}

export function isPostalCodeValid(
  countryCode: string,
  postalCode: string,
): boolean {
  const normalizedCountryCode = countryCode.toUpperCase();
  const normalizedPostalCode = normalizePostalCode(
    normalizedCountryCode,
    postalCode,
  );

  if (!normalizedPostalCode) {
    return !isPostalCodeRequired(normalizedCountryCode);
  }

  if (normalizedCountryCode === "US") {
    return /^\d{5}$/.test(normalizedPostalCode)
      ? inferRegionCode(normalizedCountryCode, normalizedPostalCode) !== null
      : false;
  }

  if (normalizedCountryCode === "XX") {
    return normalizedPostalCode.length >= 3 && /\S/.test(normalizedPostalCode);
  }

  return (
    POSTAL_PATTERNS[normalizedCountryCode]?.test(normalizedPostalCode) ?? true
  );
}
